

export enum Vertical {
    Dental = '#ea731f',
    EquipmentProvider = '#0072BC'
  }

